(function ($) {
  "use strict";

  $(function () {

    var $body = $('body');
    var $heroImage = $('.heroImage .hero-image');
    // Loading of Hero element
    function initHeroImage(prevDevice) {
      var ww = window.innerWidth,
        src;
      if ($heroImage.length > 1) {
        $heroImage.each(function () {
          setHeroImage($(this));
        });
      }
      else if ($heroImage.length === 1) {
        setHeroImage($heroImage);
      }
      function setHeroImage(image) {
        if (ww < 768) {
          src = image.attr('data-src-mobile');
          image.attr('data-device', 'mobile');
        }
        else if (ww < 992) {
          src = image.attr('data-src-tablet');
          image.attr('data-device', 'tablet');
        }
        else {
          src = image.attr('data-src-desktop');
          image.attr('data-device', 'desktop');
        }

        if (image.hasClass('lazyloaded') || image.attr('data-device') != prevDevice) {
          image.removeClass('lazyloaded');
          var downloadingImage = new Image();
          downloadingImage.onload = function () {
            image.addClass('lazyloaded').css('background-image', 'url(' + this.src + ')');
          };
          downloadingImage.src = src;
        }
      }
    };
    $(window).resize(function () {
      initHeroImage($heroImage.attr('data-device'));
    });

    // Detect scrolling for navbar and sharing icons
    $(window).scroll(function () {
      if ($(window).scrollTop() <= $('.heroImage').outerHeight() - 100) {
        $body.removeClass('scrolling');
      }
      else {
        $body.addClass('scrolledAfterHero');
        $body.addClass('scrolling');
      }
    });

    // Function for centering dots
    function positionCarouselDots() {
      var width = $('.FrontPage .hero-carousel .slick-active .hero-carousel__slide-blurb').outerWidth();

      $('.FrontPage .hero-carousel .slick-dots').css('left', Math.ceil(width / 2) + 'px');
    }

    /**
 * Throttles a function, limiting its execution to once every 'delay' milliseconds.
 *
 * @param {number} delay - The delay in milliseconds.
 * @param {boolean} [no_trailing] - Optional. If true, prevents the function from running at the end of the throttle period.
 * @param {function} callback - The function to throttle.
 * @param {boolean} [debounce_mode] - Optional. If true, runs the function at the beginning of the period (used by debounce).
 * @returns {function} The new throttled function.
 */
    function throttle(delay, no_trailing, callback, debounce_mode) {
      var timeout_id,
        last_exec = 0;

      // Handle the case where the optional 'no_trailing' argument is omitted
      if (typeof no_trailing !== "boolean") {
        debounce_mode = callback;
        callback = no_trailing;
        no_trailing = undefined;
      }

      function wrapper() {
        var self = this,
          elapsed = +new Date() - last_exec,
          args = arguments;

        function exec() {
          last_exec = +new Date();
          callback.apply(self, args);
        }

        function clear() {
          timeout_id = undefined;
        }

        if (debounce_mode && !timeout_id) {
          exec(); // Run at the beginning (for debounce 'at_begin')
        }

        // Clear any existing timeout
        timeout_id && clearTimeout(timeout_id);

        if (debounce_mode === undefined && elapsed > delay) {
          // Standard throttle behavior
          exec();
        } else if (no_trailing !== true) {
          // Set up the trailing edge call
          timeout_id = setTimeout(
            debounce_mode ? clear : exec,
            debounce_mode === undefined ? delay - elapsed : delay
          );
        }
      }

      return wrapper;
    }

    /**
    * Debounces a function, delaying its execution until 'delay' ms have passed
    * since the last time it was invoked.
    *
    * @param {number} delay - The delay in milliseconds.
    * @param {boolean|function} at_begin - Can be a boolean (if true, run at the beginning) or the callback function.
    * @param {function} [callback] - The function to debounce (if 'at_begin' was a boolean).
    * @returns {function} The new debounced function.
    */
    function debounce(delay, at_begin, callback) {

      // This handles two different ways of calling debounce:

      if (callback === undefined) {
        // 1. Signature: debounce(delay, callback)
        // 'at_begin' is actually the callback.
        // 'false' is passed as the 'debounce_mode' to throttle, meaning "run at the end".
        return throttle(delay, at_begin, false);
      } else {
        // 2. Signature: debounce(delay, at_begin, callback)
        // 'at_begin !== false' is passed as the 'debounce_mode' to throttle.
        // This makes it run at the beginning if at_begin is true.
        return throttle(delay, callback, at_begin !== false);
      }
    }

    $('.hero-carousel').on('init', function (slick) {
      if ($('.FrontPage .hero-carousel .slick-dots').length) {
        $(window).resize(debounce(500, function () {
          positionCarouselDots();
        }));

        positionCarouselDots();
      }
    });

    // Carousel for Spotlight FeatureTile
    $('.spotlight .row').slick({
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      adaptiveHeight: false,
      arrows: true,
      centerMode: false,
      infinite: false,
      mobileFirst: true
    });

    // Carousel for Hero
    if ($('.hero-carousel .hero-carousel__slide').length > 1) {
      $('.hero-carousel').slick({
        dots: true,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        arrows: false
      });
    }

    //event block page for filter clear all btn to be in same line near search btn

    $(document).ready(function () {

      var $container = $("#LatestFilterEventPagesListingFilters");

      var $filterRow = $container.find(".EventLandingPage__industries--titleWithFilters");
      var $clearButton = $container.find(".clearButton");
      var $searchWrapper = $container.find(".searchWrapper");

      // Move Clear button after Search
      $searchWrapper.before($clearButton);

      // Hide by default if required
      $clearButton.find(".roundedBtn").addClass("disabled");

    });

    // Local Video Block play button 
    setTimeout(function () {
      $(window).on('resize', function () {
        $('.local-video-block_desktop').each(function () {
          var $videoBlock = $(this);
          $videoBlock.find('.playBtn').unbind('click').click(function () {

            $videoBlock.find('.buttonWrapper').hide();
            $videoBlock.find('.local-desktop-video').attr("controls", '');
            document.getElementById("local-video_dsktp").play();
          });
        });

        $('.local-video-block_mobile').each(function () {
          var $videoBlock = $(this);
          $videoBlock.find('.playBtn').unbind('click').click(function () {

            $videoBlock.find('.buttonWrapper').hide();
            $videoBlock.find('.local-mobile-video').attr("controls", '');
            document.getElementById("local-video_mb").play();
          });
        });
      }).resize();
    }, 400);

    /*
    MAIN NAVIGATION
    */
    var $mainNavigation = $('.navbar');

    (function ($mainNavigation, $body) {
      function closeNavigation() {
        $mainNavigation.find('#navbarDropdown').collapse('hide');
        $body.removeClass('pageOverlay');
        $hamburger.removeClass('is-active');
        if ($body.hasClass('tietoevry2022')) {
          $body.removeClass('navbar-open');
        }
      }
      function openNavigation() {
        closeLanguageNav();
        $body.addClass('pageOverlay');
        $hamburger.addClass('is-active');
        if ($body.hasClass('tietoevry2022')) {
          $body.addClass('navbar-open');
        }
        // Accessibility - we need to unable tabbing of hidden menu items
        $mainNavigation.find('#navbarDropdown').find('.dropdown-menu').hide();
      }

      // hamburger icon animation
      var $hamburger = $mainNavigation.find('.hamburger');
      var frozenTime = 500;
      $hamburger.on("click", function (e) {
        var isFrozen = $hamburger.attr('data-frozen');
        isFrozen = (isFrozen === 'true');

        if (isFrozen) {
          return false;
        }

        $hamburger.attr('data-frozen', !isFrozen);
        var hamburgerTimeout = window.setTimeout(function () {
          $hamburger.attr('data-frozen', isFrozen);
          clearTimeout(hamburgerTimeout);
        }, frozenTime);

        if ($hamburger.hasClass('is-active')) {
          closeNavigation();
        } else {
          openNavigation();
        }
      });
      if (window.innerWidth < 992) {
        closeLanguageNav();
        closeNavigation();
      }
      $body.click(function (e) {

      });

      // when you hover a toggle show its dropdown menu
      $(".nav-item.dropdown").mouseenter(function () {
        if (window.innerWidth > 991.98) {
          $body.addClass('pageOverlay dropdownShown');
        }
      });

      // hide the menu when the mouse leaves the dropdown
      $(".nav-item.dropdown").mouseleave(function () {
        if (window.innerWidth > 991.98) {
          closeMainMenuItem(this);
        }
      });

      // Accessibility changes for main menu (keyboard navigation support).
      // With enter key click the item.
      // Open/close the hovering layer with space.
      // Close with esc.
      $('.navbar-nav>.nav-item>.nav-item>.nav-link').keydown(function (event) {
        var key = event.keyCode;
        var $parent = $(this).parent();
        if (key === 13) { // enter
          $(this).find('span').click();
        }
        else if (key === 32) { // space
          event.preventDefault(); event.stopPropagation();
          if ($parent.hasClass('dropdown-toggle')) {
            $parent.dropdown('toggle');
            if ($body.hasClass('dropdownShown')) {
              closeMainMenuItem($parent);
            }
            else {
              $body.addClass('pageOverlay dropdownShown');
            }
          }
        }
        else if (key === 27) { // esc
          event.preventDefault(); event.stopPropagation();
          if ($parent.hasClass('dropdown-toggle') && $body.hasClass('dropdownShown')) { // Is the hovering sub menu open?
            $parent.dropdown('toggle');
            closeMainMenuItem($parent);
          }
        }
      });

      // Accessibility changes for main menu arrow icons in mobile widths (keyboard navigation support).
      $('.navbar-nav>.nav-item>.nav-item>svg.icon').keydown(function (event) {
        var key = event.keyCode;
        var $menuItem = $(this).parent();
        if (key === 13 || key === 32) { // enter or space
          event.preventDefault(); event.stopPropagation();
          if ($menuItem.hasClass('dropdown-toggle')) {
            $menuItem.dropdown('toggle');
          }
        }
        else if (key === 27) { // esc
          event.preventDefault(); event.stopPropagation();
          if ($menuItem.hasClass('dropdown-toggle') && $menuItem.parent().hasClass('show')) { // Is the hovering sub menu open?
            $menuItem.dropdown('toggle');
          }
        }
        //}
        $(this).focus();
      });

      $('#navbarDropdown>.navbar-nav>.dropdown').on('show.bs.dropdown', function () {
        if (window.innerWidth < 992) {
          $(this).find('.dropdown-menu').show();
        }
      });
      $('#navbarDropdown>.navbar-nav>.dropdown').on('hide.bs.dropdown', function () {
        if (window.innerWidth < 992) {
          $(this).find('.dropdown-menu').hide();
        }
      });

      function closeMainMenuItem(el) {
        if (window.innerWidth > 991.98) {
          $body.removeClass('pageOverlay dropdownShown');
          $('.dropdown-menu').removeClass('show');
          resetDynamicNavigation(el);
        }
      }

      // re-set dynamic navigation to show parent element contents.
      function resetDynamicNavigation(navItem) {
        var firstBreadCrumb = $(navItem).find(".container .dynamicNavigation .subNavBlock a.load-sub-nav.breadcrumb-item:first")
        if (firstBreadCrumb.length) {
          $(firstBreadCrumb).click();
        }
      }

      // Language selection
      function openLanguageNav() {
        closeNavigation();
        $body.addClass('pageOverlay');
      }
      function closeLanguageNav() {
        $mainNavigation.find('#languageSelectionDropdown').collapse('hide');
        $body.removeClass('pageOverlay');
      }
      $mainNavigation.find('.languageNav__current')
        .click(function (e) {
          if (!$(e.target).hasClass('languageNav__dropdown')) {
            if ($mainNavigation.find('.languageNav__current').hasClass('collapsed')) {
              openLanguageNav();
            }
            else {
              closeLanguageNav();
            }
          }
        })
        .keydown(function (e) {
          var key = e.keyCode;
          if (key === 13 || key === 32) { // Enter or space keys are toggling the language menu.
            event.preventDefault(); event.stopPropagation();
            $(this).click();
          }
          else if (key === 27) { // With esc key close the language menu
            closeLanguageNav();
          }
        });
      $mainNavigation.find('.languageNav__item > a').keydown(function (e) {
        if (e.keyCode === 27) { // With esc key close the language menu
          $mainNavigation.find('.languageNav__current').focus();
          closeLanguageNav();
        }
      });
    })($mainNavigation, $body);

    // Lazyload
    $(".lazyload").lazyload();

    // Lazyload all images before print
    //$(".lazyload").lazyload({
    //    event: "onBeforePrint"
    //});
    //{
    //    var onbeforeprintTrigger = function () {
    //        $(".lazyload").trigger("onbeforeprint");
    //    };
    //    if (window.matchMedia) {
    //        var mediaQueryList = window.matchMedia('print');
    //        mediaQueryList.addListener(function () {
    //            onbeforeprintTrigger();
    //        });
    //    }
    //    window.onbeforeprint = onbeforeprintTrigger;
    //    window.onafterprint = onbeforeprintTrigger;
    //}


    /*
    Fix for episerver edit mode
    */
    // Check if pages are inside iframe
    if (window.self !== window.top) {
      console.log('is episerver');
      //1% of the parent viewport width/height:
      var vw = window.parent.innerWidth / 100,
        vh = window.parent.innerHeight / 100,
        $epiHero = $('.jumbotron'),
        $body = $('body');

      $epiHero.css({
        'padding-top': 25 * vh,
        'padding-bottom': 25 * vh,
        'min-height': 82 * vh
      });

      if (
        $body.hasClass('NewsListingPage') ||
        $body.hasClass('CaseListingPage') ||
        $body.hasClass('JobListingPage') ||
        $body.hasClass('EventListingPage') ||
        $body.hasClass('ReleaseListingPage') ||
        $body.hasClass('SubscriptionPage') ||
        $body.hasClass('SearchPage') ||
        $body.hasClass('CorporateFocusPage') ||
        $body.hasClass('CorporateEntrancePage')) {
        $epiHero.css({
          'min-height': 20 * vh
        });
      }
      else if ($body.hasClass('FrontPage')) {
        $epiHero.css({
          'padding-top': 32 * vh,
          'min-height': 90 * vh
        });
      }
      else if (
        $body.hasClass('PressReleasePage') ||
        $body.hasClass('CorporateContentPage') ||
        $body.hasClass('BasicContentPage') ||
        $body.hasClass('JobPage') ||
        $body.hasClass('BoadOfDirectorsPage') ||
        $body.hasClass('BoardOfDirectorsCollectionPage')) {
        $epiHero.css({
          'padding-bottom': 10 * vh,
          'padding-top': 20 * vh,
          'min-height': 25 * vh
        });
      }
    }
    //New line fix for Benefit Block and Checker Board Block
    $('.benefitBlock p').each(function () {
      var text = $(this).html();
      $(this).html(text.replaceAll('\n', '<br \>'));
    });

    $('.checkerBlock p').each(function () {
      var text = $(this).html();
      $(this).html(text.replaceAll('\n', '<br \>'));
    });
    //slider for event block
    // $(".event-block .eventBlockThree").removeClass("slidershow");
    $('.event-block .eventBlockFive.slidershow').each(function () {
      var $slideshow = $(this);
      $slideshow.slick({
        dots: false,
        autoplay: false,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        centerMode: false,
        infinite: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 240,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ],
        lazyLoad: 'ondemand'
      });
      $slideshow.find('.case').on('mousedown', function () {
        $slideshow.find('.case').addClass('slider-focused');
      });
      $slideshow.on('mouseup', function () {
        $slideshow.find('.case').removeClass('slider-focused');
      });
    });


    $('.event-block .eventBlockThree.slidershow').each(function () {
      var $slideshow = $(this);
      $slideshow.slick({
        dots: false,
        autoplay: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
        infinite: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 240,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ],
        lazyLoad: 'ondemand'
      });
      $slideshow.find('.case').on('mousedown', function () {
        $slideshow.find('.case').addClass('slider-focused');
      });
      $slideshow.on('mouseup', function () {
        $slideshow.find('.case').removeClass('slider-focused');
      });
    });


    //slider offering promotion block for new focus page
    $(".addcarouseleffect .offeringPromotion2_0 .lessThan4items").removeClass("slidershow");

    if ($(window).width() < 767) {
      $(".addcarouseleffect .offeringPromotion .lessThan4items").addClass("slidershow");
    } else {
      $(".addcarouseleffect .offeringPromotion .lessThan4items").removeClass("slidershow");
    }

    $('.addcarouseleffect .offeringPromotion2_0 .slidershow').each(function () {
      var $slideshow = $(this);
      $slideshow.slick({
        dots: false,
        autoplay: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ],
        lazyLoad: 'ondemand'
      });
      $slideshow.find('.case').on('mousedown', function () {
        $slideshow.find('.case').addClass('slider-focused');
      });
      $slideshow.on('mouseup', function () {
        $slideshow.find('.case').removeClass('slider-focused');
      });
    });

    // Slider
    $('.slider').each(function () {
      var $slideshow = $(this);
      $slideshow.slick({
        dots: false,
        autoplay: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 484,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ],



        lazyLoad: 'ondemand'
      });
      $slideshow.find('.case').on('mousedown', function () {
        $slideshow.find('.case').addClass('slider-focused');
      });
      $slideshow.on('mouseup', function () {
        $slideshow.find('.case').removeClass('slider-focused');
      });
    });

    // Append ... to long news/case block title
    var $slide = $('.newsCaseBlock .case');
    $(window).on('resize', function () {
      $slide.find('.text span').removeClass('lastVisible');
      $slide.find('.text').each(function () {
        var $this = $(this);
        if ($.trim($this.text()).length) {
          var words = $this.text().split(' '),
            textHeight = $this[0].scrollHeight;
          $this.empty();
          $.each(words, function (i, v) {
            $this.append($("<span> ").text(v + ' '));
          });

          $this.find('span').each(function () {
            var $theSpan = $(this);
            if ($theSpan.offset().top + $theSpan.height() > $this.offset().top + $this.innerHeight() - parseFloat($this.css('padding-bottom'))) {
              $theSpan.prev().addClass('lastVisible');
              return false;
            }
          });
        }
      });
    });

    // Add class table to all tables
    $('table').not('.peoplegroup').not('.Index').each(function () {
      $(this).wrap('<div class="table-wrapper"/>').addClass('table').stackedRows();
    });

    // Search input events
    $('.search').each(function () {
      initSearch(this);
    });

    // Autocomplete to search inputs
    var lang = $('html').attr('lang'),
      xhr;
    $('.search-autocomplete').each(function () {
      initAutocomplete(this, lang, xhr);
    });

    // CheckboxGroup

    $('.checkboxGroup').each(function () {
      var $this = $(this);
      $this.find('a').click(function () {
        var $clicked = $(this);

        if ($clicked.find('input[type=checkbox]').is(':checked')) {
          $clicked.find('input[type=checkbox]').prop('checked', false);
          $clicked.removeClass('blueBtn').addClass('whiteBtn');
        }
        else {
          $clicked.find('input[type=checkbox]').prop('checked', true);
          $clicked.removeClass('whiteBtn').addClass('blueBtn');
          // Hide error message if any of checkboxes is checked
          $this.siblings('#languageSelectionError').empty();
        }
        return false;
      })

    });

    // Detect switch from local site to en version
    (function () {
      if ($('html').attr('lang') !== 'en') {
        var $siteSwitchModal = $('#SiteSwitchPopup');
        const defaultSiteSwitchPopupMessage = $('#SiteSwitchPopup .modal-body .col-md-12').text();

        $('li.languageNav__item > a:first-child')
          .not('[href=\\#]')
          .not('.ccb__edit')
          .not('[target=_blank]')
          .click(function (e) {
            var url = $(this).attr('href');

            if (url.replace(/^\/([^\/]*).*$/, '$1') == 'en') {
              e.preventDefault();

              var switchingLanguageName = $(this).text();
              var siteSwitchPopupMessage = $('#SiteSwitchPopup .modal-body .col-md-12');

              // It replaces any placeholder like "{0}", "{1}", etc. with the 'clickedLanguageText' obtained from the clicked link.
              siteSwitchPopupMessage.text(siteSwitchPopupMessage.text().replace(/{\d+}/g, switchingLanguageName));

              $siteSwitchModal.modal();

              $siteSwitchModal.find('.leavePage').click(function () {
                location.href = url;
              });

              $siteSwitchModal.find('.stayOnPage').click(function () {
                siteSwitchPopupMessage.text(defaultSiteSwitchPopupMessage);
              });

            }
          });
      }
    })();

    // Select all checkboxes

    $('input[type=checkbox][data-type=select-all]').click(function () {
      var cb = $(this),
        name = cb.attr('data-for');

      if (name === null)
        return false;
      $('input[type=checkbox][data-selector^=' + name + ']')
        .prop('checked', cb.prop('checked'))
        .click(function () {
          if (!$(this).prop('checked'))
            cb.prop('checked', false);
        });
    });

    // Submit button 
    $('#submitButton').click(function (e) {
      $(this).parents('form').submit();
      e.preventDefault();
    });

    // Transform subNavBlock into dropdown
    var $arrowLinkBlock = $('.subNavBlock');
    if ($arrowLinkBlock.length) {
      $(window).resize(function () {
        $arrowLinkBlock.find('.arrowLinkHeading').unbind('click');
        if (window.innerWidth < 768) {
          $arrowLinkBlock.find('.arrowLinkHeading').click(function () {
            $arrowLinkBlock.find('.subnavigation-description').toggle(200);
            $arrowLinkBlock.find('.arrowLinkBody').slideToggle(200);
            $arrowLinkBlock.toggleClass('subnavigationShown');
          });
        }
        else {
          $arrowLinkBlock.find('.arrowLinkBody').show();
        }
      });
    }

    // For adjusting Subnavigation other links blocks when there are no child pages in epi
    //if ($(".arrowLinkHeading span.subnavigation-title_desktop").is(':empty')) {
    //    $('.arrowLinkHeading span.subnavigation-title_desktop').hide();
    //    $('.arrowLinkBody h4.subnavigation-subtitle').css('margin-top', '0px');
    //    $('.arrowLinkBody h4.subnavigation-subtitle').css('padding-top', '0px');
    //}

    // Hide/Show text depending on whether the subnavigation-title_desktop text is present or not (alternative fix for above commented code)
    if ($('.arrowLinkHeading span.subnavigation-title_desktop').text().length > 0) {
      $('.arrowLinkHeading span.subnavigation-title_desktop').show()
    } else {
      $('.arrowLinkHeading span.subnavigation-title_desktop').hide()
    }

    if ($(window).width() < 767) {
      $('.arrowLinkBody h4.subnavigation-subtitle').hide();
    }

    // Accordions - add active class for selected card
    $('.collapse').on('shown.bs.collapse', function () {
      $(this).parents('.card').addClass('active');
    });

    $('.collapse').on('hidden.bs.collapse', function () {
      $(this).parents('.card').removeClass('active');
    });

    // Investis iframes
    $('iframe[src*="viz.tools.investis.com"], iframe[src*="visualisation.investis.com"]').each(function () {
      var $this = $(this);

      if ($this.attr('id') !== 'invdct-iframe') {
        // Add id and class needed and reload its content
        $this.attr('id', 'invdct-iframe').addClass('responsive');
      }
      $this.attr("src", $this.attr('src'));
      // Set proper iframe height sent from investis
      window.addEventListener('message', function (event) {
        if (event.origin !== 'http://viz.tools.investis.com' && event.origin !== 'https://viz.tools.investis.com' && event.origin !== 'http://visualisation.investis.com') return;
        $this.height(event.srcElement.innerHeight);
      }, false);
    });

    // Videoblock

    window.addEventListener("OneTrustGroupsUpdated", event => {
      if (!event.detail.includes('C0004')) {
        $(".videoPreview").hide();
        $(".optinon-youtube").show();
      } else {
        $(".videoPreview").show();
        $(".optinon-youtube").hide();
      }
    });
    setTimeout(function () {
      $(window).on('resize', function () {
        $('.videoBlock').each(function () {
          var $videoBlock = $(this);
          $videoBlock.find('.playBtn').unbind('click').click(function () {

            $videoBlock.find('.videoPreview').hide();
            $videoBlock.find('.videoPreview + div').show();
            $videoBlock.find('iframe').height($videoBlock.find('iframe').width() * 9 / 16);
            $videoBlock.find('iframe')[0].src += ($videoBlock.find('iframe')[0].src.indexOf('?') === -1) ? "?autoplay=1" : "&autoplay=1";

          });
        });
      }).resize();
    }, 400);

    //NICE SELECT
    var $select = $('select').not('.multiselect');
    if ($select.length) {
      $select.niceSelect();
    }

    $('#CitySelect').multiselect();

    // news/case listing page
    if ($body.hasClass('NewsListingPage') || $body.hasClass('CaseListingPage'))
      initNewsCaseListing();

    // webinar listing page
    if ($body.hasClass('WebinarListingPage')) {
      initWebinarListing();

    }

    // job listing page
    if ($body.hasClass('JobListingPage'))
      initJobListing();

    // event/release listing page 
    if ($body.hasClass('EventListingPage') || $body.hasClass('ReleaseListingPage') || $body.hasClass('EventPage'))
      initTextViewListing($body.hasClass('ReleaseListingPage'));

    // get search results
    if ($body.hasClass('SearchPage'))
      initSearchView();

    if ($body.hasClass('BlogLandingPage') || $body.hasClass('BlogThemePage') || $body.hasClass('BlogPostPage') || $body.find(".LocalBlogPostListingBlock").length)
      initLatestBlogPostsBlockListing();

    if ($body.find('div.latestBlogsByCategoryFilterBlock').length)
      initLatestBlogByCategoryBlockListing();

    if ($body.hasClass('BlogLandingPage'))
      initLatestFilterBlogPostPagesListing();

    if ($body.hasClass('EventLandingPage'))
      initLatestFilterEventPagesListing();

    /*
    FRONTPAGE blocks
    */
    $body.find('.heroArrowDown').click(function () {
      $('html,body').animate({
        scrollTop: $('.jumbotron').outerHeight()
      }, 'slow');
    });

    if ($body.hasClass('FrontPage') && $body.find('.jumbotron .ticker__wrapper').length) {

      // Newsticker
      $(window).resize(function () {
        var isMobile = window.innerWidth < 992;
        var $hero = $('.jumbotron');
        var ticker = $hero.find('.ticker__wrapper').show().easyTicker({
          direction: 'up',
          easing: 'swing',
          speed: 'slow',
          interval: 5000,
          height: 'auto',
          visible: 3,
          mousePause: 1,
          controls: {
            up: '.ticker__heading'
          }
        });
        if (isMobile) {
          ticker.data('easyTicker').options.visible = 1;
          //$hero.find('.ticker__inner').unbind('DOMSubtreeModified')
        }
        else {
          ticker.data('easyTicker').options.visible = 3;
          //var scrollPosition = 0;
          //var scrollMove = 0;
          //$hero.find('.ticker__inner').unbind('DOMSubtreeModified').on("DOMSubtreeModified", function () {
          //	scrollPosition++;
          //	switch (scrollPosition) {
          //		case 2:
          //			scrollMove = '33.3333%';
          //			break;
          //		case 4:
          //			scrollMove = '66.6666%';
          //			break;
          //		case 6:
          //			scrollMove = 0;
          //			scrollPosition = 0;
          //			break;
          //		default:
          //			scrollMove = 0;
          //	}
          //	$hero.find('.ticker__scrollbar span').css('top', scrollMove);
          //})
        }
      });


      // Frontpage case block
      var $frontpageCaseBlock = $('.frontPageCaseBlock >div');
      if (window.innerWidth < 768) {
        $frontpageCaseBlock.slick({
          dots: false,
          autoplay: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          infinite: false,
          mobileFirst: true,
          focusOnChange: false,
          responsive: [
            {
              breakpoint: 484,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ],
          lazyLoad: 'ondemand'
        });
      }
    }

    // CONTACTPAGE block
    if ($body.hasClass('ContactPage')) {
      $body.find('.jumbotron a').each(function () {
        if ($(this).prop("hash") == '#modal') {
          $(this).click(function (e) {
            e.preventDefault();
            $body.find('#ContactPageModal .modal').modal();
          });
        }
      });
    }

    //cyrilic font for ua

    if ($('html').attr('lang') === 'uk-UA') {
      $(".tietoevry2022").addClass("cyrilic_font");
    }


    /* TEMPORARY */
    /* main nav - make first nav item external links _blank */
    $('.navbar-nav .nav-item').eq(0).find('a').each(function () {
      var a = new RegExp('/' + window.location.host + '/');
      if (!a.test(this.href)) {
        $(this).attr('target', '_blank');
      }
    });

    // Remove margins from blockwrappers (blocks with fullwidth backgroud color) that are immediatelly after each other or which are last block on the page
    $('.blockWrapper').each(function () {
      var $this = $(this);
      if ($this.parent().next().find('>.blockWrapper').length || !$this.parent().next().length)
        $this.css('margin-bottom', 0);
    });

    /* Meet our experts */
    $body.find('.MeetOurExpertsPage__content--item').each(function () {
      var $expert = $(this);
      var $modal = $body.find('#MeetOurExpertsModal');
      $expert.click(function () {
        $.ajax({
          url: $expert.attr('data-url'),
          type: 'GET',
          success: function (data) {
            $modal.find('.modal-body').html(data);
            $modal.modal();
          },
          error: function (xhr, status, error) {
            $modal.find('.modal-body').html('<div class="row"><div class="col-12"><p>Error: ' + error + '</p></div></div>');
            $modal.modal();
          }
        });
      });
    });
    if (!$body.hasClass('MicrositePage')) {
      $body.find('.imageGalleryBlock').each(function () {
        $(this).find('a.js-gallery').featherlightGallery({
          previousIcon: '<svg class="icon icon-arrowBreadcrumb"><use xlink:href="#icon-arrowBreadcrumb"></use></svg>',
          nextIcon: '<svg class="icon icon-arrowBreadcrumb"><use xlink:href="#icon-arrowBreadcrumb"></use></svg>',
          root: $(this)
        });
      });
    }

    equalHeights();
    $(window).resize(function () {
      if (window.innerWidth >= 768) {
        equalHeights();
      }
    });
  });

  $(window).on('load', function () {
    initSocialMediaFeed($('.socialMediaFeedBlock'));
  });

  //CAMPAIGN POPUP
  var $CampaignPopup = $('#CampaignPopup'),
    CampaignId = $CampaignPopup.attr('data-campaignid');
  if ($CampaignPopup.length) {
    $CampaignPopup.on('hide.bs.modal', function (event) {
      setCookie('CapmaignCookieShown' + CampaignId, true, 365);
    });
    if (!readCookie('CapmaignCookieShown' + CampaignId)) {
      $CampaignPopup.modal();
    }
  }
  //Hide Campaign job block if there are no results 
  $(".deleteThis").parent().hide();
})(jQuery);

// Initial value for close button in filtering search input
var closeBtnClicked = false;

var initSocialMediaFeed = function ($el) {
  $el.each(function () {
    $feed = $(this);
    var $grid = $feed.masonry({
      itemSelector: '.col-md-4',
      percentPosition: true
    });

    $feed.parent().find('.socialMediaFeedShowMoreBtn').click(function (e) {
      if (!$(this).hasClass('disabled')) {
        var blockId = $(this).attr('data-blockId');
        var culture = $(this).attr('data-culture');
        SocialMediaFeedBlock$ShowMorePosts(blockId, culture, $grid);
      }
      e.preventDefault();
    });
  });
};

var initSearch = function (el) {
  var $this = $(el),
    $theNavbar = $this.parents('.navbar'),
    $theSearchpage = $this.parents('.SearchPage'),
    $theInput = $this.find('input[type=search]'),
    $theCloseBtn = $this.find('.closeBtn'),
    $theSearchBtn = $this.find('.searchBtn');

  $('body').on("mouseup touchend", function (e) {
    var container = $($theInput);

    if (!container.is(e.target) // if the target of the click isn't the container...
      && container.has(e.target).length === 0) // ... nor a descendant of the container
    {
      container.removeClass("open");
      $($theInput).blur();
    }
  });

  $theCloseBtn
    .click(function () {
      closeBtnClicked = true;
      $theCloseBtn.hide();
      $theInput.val('');
      setTimeout(function () {
        $theInput.trigger('change').focus();
      });
    });

  if ($theInput.val() == '') {
    $this.addClass('collapsed');
    $theSearchBtn.addClass('disabled');
    $theCloseBtn.hide();
  }

  $theInput
    .bind('input', function () {
      if ($theInput.val() == '')
        $theCloseBtn.hide();
      else {
        $theCloseBtn.show();
        if ($theInput.val().length >= 2) {
          $theSearchBtn.removeClass('disabled');
        }
        else {
          $theSearchBtn.addClass('disabled');
        }
      }

    })
    .on('blur', function () {
      if ($theInput.val() == '') {
        $theNavbar.removeClass('searchExpanded');
        $this.addClass('collapsed');
      }
    })
    .on('touchleave touchcancel', function () {
      if ($theInput.val() == '') {
        $theNavbar.removeClass('searchExpanded');
        $this.addClass('collapsed');
      }
    })
    .on('invalid', function (el) {
      if ($theInput.val() == '') {
        el.preventDefault();
        $theNavbar.removeClass('searchExpanded');
        $this.addClass('collapsed');
      }
    });

  $theSearchBtn
    .on('click', function (e) {
      if (($theNavbar.length || $theSearchpage.length) && $theInput.val().length == 1) {
        return false;
      }

      if ($(window).width() > 768) {
        if ($this.hasClass('collapsed')) {
          $theNavbar.addClass('searchExpanded');
          $this.removeClass('collapsed');
          setTimeout(function () {
            $theInput.trigger('focus');
          }, 400);
          e.preventDefault();
        }
      } else {
        if ($this.hasClass('collapsed')) {
          $theNavbar.removeClass('searchExpanded');
          $this.removeClass('collapsed');
          setTimeout(function () {
            $theInput.trigger('focus');
          }, 400);
          e.preventDefault();
        }
      }


    });
};

var initAutocomplete = function (el, lang, xhr) {
  var $this = $(el);
  $this.autoComplete({
    source: function (term, response) {
      try { if (xhr) xhr.abort(); } catch (e) { }
      xhr = $.get("/find_v2/_autocomplete?prefix=" + encodeURIComponent(term) + "&size=3",
        function (data) {
        response($.map(data.hits || [], function (item) {
          return item.query;
          }));
        },
        "json"
      );
    },
    minChars: 2,
    onSelect: function (e, term, item) {
      $this.val(term);
      $this.closest('form').submit();
    }
  });
};

var initNewsCaseListing = function initNewsCaseListing() {
  initFiltering($('#newsCaseListingPageFilters'), filterNewsCasePages);
  initListingLoadMoreButton('a#newsCaseListingPageLoadMore', $('a#newsCaseListingPageLoadMore').closest('div.listingResults').find('>div'));
};

var filterNewsCasePages = function filterNewsCasePages(container, url) {
  container.parents('.container-fluid').addClass('loading');
  $.get(
    url + '&filters=true',
    function (data) {
      container.closest('div.container-fluid').replaceWith(data).removeClass('loading');
      $('select').niceSelect();
      initNewsCaseListing();
    }
  );
};

var initWebinarListing = function () {
  initFiltering($('#webinarListingPageFilters'), filterWebinarListingPages);
  initListingLoadMoreButton('a#webinarListingPageLoadMore', $('a#webinarListingPageLoadMore').closest('div.listingResults').find('>div'));
  initVideoButtons();
};

var filterWebinarListingPages = function (container, url) {
  container.parents('.container-fluid').addClass('loading');
  $.get(
    url + '&filters=true',
    function (data) {
      container.closest('div.container-fluid').replaceWith(data).removeClass('loading');
      $('select').niceSelect();
      initWebinarListing();
    }
  );
};

var initJobListing = function initJobListing() {
  initJobPageFiltering($('#jobListingPageFilters'), filterJobPages);
  initListingLoadMoreButton('a#jobListingPageLoadMore', $('a#jobListingPageLoadMore').closest('div.jobResults').find('div.listingResults'));
};

var filterJobPages = function filterJobPages(container, url) {
  container.parents('.container-fluid').addClass('loading');
  $.get(
    url + '&filters=true',
    function (data) {
      container.closest('div.container-fluid').replaceWith(data).removeClass('loading');
      $('#CountrySelect').multiselect();
      $('#CitySelect').multiselect();
      $('#JobAreaSelect').multiselect();
      $('#JobRoleSelect').multiselect();
      $('#RemoteTypeSelect').multiselect();
      initJobListing();
    }
  );
};

var initTextViewListing = function initTextViewListing(isReleaseListing) {
  initFiltering($('#textViewListingPageFilters'), filterTextViewPages, isReleaseListing ? 'ReleaseListingPage' : '');
  initListingLoadMoreButton('a#textViewPageLoadMore', $('a#textViewPageLoadMore').closest('div.eventResults'));
};

var filterTextViewPages = function filterTextViewPages(container, url) {
  container.parents('.container-fluid').addClass('loading');
  $.get(
    url + '&filters=true',
    function (data) {

      container.closest('div.container-fluid').removeClass('loading').find('div.eventResults').html(data);
      initListingLoadMoreButton('a#textViewPageLoadMore', $('a#textViewPageLoadMore').closest('div.eventResults'));
    }
  );
};

var initSearchView = function initSearchView() {
  initListingLoadMoreButton('a#searchPageLoadMore', $('a#searchPageLoadMore').closest('div.searchResultList'));
};

var initLatestBlogPostsBlockListing = function initLatestBlogPostsBlockListing() {
  initListingLoadMoreButton('a#latestBlogPostsBlockLoadMore', $('a#latestBlogPostsBlockLoadMore').parents('div.blogTiles'), true);
};

var initLatestBlogByCategoryBlockListing = function initLatestBlogByCategoryBlockListing() {
  initCategoryBlogsLoadMoreButton('a#latestBlogsByCategoryFilterBlockLoadMore', $('a#latestBlogsByCategoryFilterBlockLoadMore').parents('div.container'), true);
};

var initLatestFilterBlogPostPagesListing = function initLatestBlogPostsBlockListing() {
  initFiltering($('#LatestFilterBlogPostPagesListingFilters'), filterLatestFilterBlogPostPages, 'blogs');
  initListingLoadMoreButton('a#LatestFilterBlogPostPagesListingLoadMore', $('a#LatestFilterBlogPostPagesListingLoadMore').parents('div.blogTiles'), true);
};

var initLatestFilterEventPagesListing = function initLatestFilterEventPagesListing() {
  initFiltering($('#LatestFilterEventPagesListingFilters'), filterLatestFilterEventPages, 'events');
  initListingLoadMoreButton('a#LatestFilterEventPagesListingLoadMore', $('.listing div.listingResults'));
};

var filterLatestFilterEventPages = function filterLatestFilterEventPages(container, url) {
  container.parents('.container-fluid').addClass('loading');
  $.get(
    url,
    function (data) {
      $('#loadMoreEvents').remove();
      container.find('div.listingResults').replaceWith(data);
      container.find('img').lazyload();
      container.parents('.container-fluid').removeClass('loading');
      initListingLoadMoreButton('a#LatestFilterEventPagesListingLoadMore', $('.listing div.listingResults'));
    }
  );
};

var filterLatestFilterBlogPostPages = function filterLatestFilterBlogPostPages(container, url) {
  container.parents('.container-fluid').addClass('loading');
  $.get(
    url,
    function (data) {
      container.find('div.filter-blog-landing-page').replaceWith(data);
      container.find('div.lazyload').lazyload();
      container.parents('.container-fluid').removeClass('loading');
      initListingLoadMoreButton('a#LatestFilterBlogPostPagesListingLoadMore', $('a#LatestFilterBlogPostPagesListingLoadMore').parents('div.blogTiles'), true);
      $('select').niceSelect();
      initLatestFilterBlogPostPagesListing();
    }
  );
};

var initListingLoadMoreButton = function initListingLoadMoreButton(loadMoreButtonSelector, resultsContainer, lazyload) {
  $(loadMoreButtonSelector).click(function (event) {
    event.stopImmediatePropagation();
    event.preventDefault();
    resultsContainer.parents('.container-fluid').addClass('loading');
    var link = $(this);
    $.get(
      link.data('url'),
      function (data) {
        if (!$(data).hasClass('listingRow') && !$(data).hasClass('CaseListingRow') && !$(resultsContainer).hasClass('searchResultList'))
          data = $(data).unwrap().html();
        link.parent().remove();
        resultsContainer.append(data);
        initListingLoadMoreButton(loadMoreButtonSelector, resultsContainer, lazyload);
        resultsContainer.parents('.container-fluid').removeClass('loading');
        if ($(data).hasClass('webinar-loadmore')) {
          initWebinarListing();
        }
        if (lazyload) {
          resultsContainer.find('.lazyload').lazyload();
        }
      }
    );
  });
};

var initCategoryBlogsLoadMoreButton = function initCategoryBlogsLoadMoreButton(loadMoreButtonSelector, resultsContainer, lazyload) {
  $(loadMoreButtonSelector).click(function (event) {

    event.preventDefault();
    resultsContainer.parents('.container-fluid').addClass('loading');
    var link = $(this);
    $.get(
      link.data('url'),
      function (data) {
        //var blogTile = $("<div />");
        //blogTile.addClass("row blogTiles relatedBlogs");
        //blogTile.append(data);

        link.parent().remove();
        resultsContainer.append(data);
        initCategoryBlogsLoadMoreButton(loadMoreButtonSelector, resultsContainer, lazyload);
        resultsContainer.parents('.container-fluid').removeClass('loading');
        if (lazyload) {
          resultsContainer.find('.lazyload').lazyload();
        }
      }
    );
  });
};

function checkQueryIsEmpty($clearButton) {
  var query = window.location.search.substring(1),
    vars = query.split('&'),
    isEmpty = true;

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[1]) !== 'undefined' && decodeURIComponent(pair[1]) !== '') {
      isEmpty = false;
    }
  }
  !isEmpty ? $clearButton.removeClass('disabled') : $clearButton.addClass('disabled');
}

var initJobPageFiltering = function initJobPageFiltering(container, filteringCallback) {
  var currentLocation = location.protocol + '//' + location.host + location.pathname;
  var $clearButton = container.children('.clearButton').find('a');
  container.find('select, input[type=search]').on('change', function (e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    if (e.target.nodeName.toLowerCase() === 'input' && e.target.value.length < 2 && !closeBtnClicked) {
      return false;
    }
    else {
      closeBtnClicked = false;
    }
    var data = [];
    container.find('select, input').each(function () {
      data[$(this).data('param')] = $(this).val();
    });

    var querystring = encodeQueryData(data);
    var historyUrl = currentLocation + '?' + querystring;
    var url;
    url = historyUrl;

    if (typeof (filteringCallback) !== 'undefined') {
      filteringCallback(container, url);
    }
    history.pushState(null, null, historyUrl);
    checkQueryIsEmpty($clearButton);
  });

  $clearButton.on('click', function (e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    var $this = $(this);
    if (typeof (filteringCallback) !== 'undefined' && !$this.hasClass('disabled')) {
      filteringCallback(container, currentLocation + '?q');
      history.pushState(null, null, currentLocation);
      container.find('select').val('');
      container.find('select').niceSelect('update');
      container.find('input').val('');
    }
    $this.addClass('disabled');
  });

  checkQueryIsEmpty($clearButton);

  // Reinitiate search input bindings
  initSearch(container.find('.search'));
};

var initFiltering = function initFiltering(container, filteringCallback, pageType) {
  var currentLocation = location.protocol + '//' + location.host + location.pathname;
  var $clearButton = pageType === "blogs" ? $("#LatestFilterBlogPostPagesListingFilters .clearButton a") : container.children('.clearButton').find('a');

  container.find('select, input').on('change', function (e) {
    if (e.target.nodeName.toLowerCase() === 'input' && e.target.value.length < 2 && !closeBtnClicked) {
      return false;
    }
    else {
      closeBtnClicked = false;
    }
    var data = [];
    container.find('select, input').each(function () {
      data[$(this).data('param')] = $(this).val();
    });
    if ($('#isJobListingPage').val() == "YES") {
      delete data.undefined;
      if (data.country.length >= 2 || data.country.length == 0) {
        data.city = "";
      }
    }
    var querystring = encodeQueryData(data);
    var historyUrl = currentLocation + '?' + querystring;
    var url;
    if (pageType === "blogs")
      url = currentLocation + '/filter?' + querystring;
    else if (pageType === "events") {
      var blockId = container.find('.listingResults').data('block-id'),
        language = container.find('.listingResults').data('language');
      url = '/LoadContentApi/Events?contentId=' + blockId + '&language=' + language + '&skip=0';
      url +=  '&eventType=' + data.type + '&timing=' + data.timing + '&country=' + data.country
        

      if (data.q !== '') {
        url += '&q=' + data.q;
      }
    }
    else
      url = historyUrl;

    if (typeof (filteringCallback) !== 'undefined') {
      // Refresh dropdown values
      if (pageType === 'ReleaseListingPage') {
        container.parents('.container-fluid').addClass('loading');
        filtersUrl = currentLocation + '/RefreshFilters?' + querystring;
        $.get(
          filtersUrl + '&filters=true',
          function (filterdata) {
            var $filterRow = $('.filterRow');
            container.closest('div.container-fluid').removeClass('loading');

            refreshDropdown('type', filterdata.ReleaseTypes, filterdata.TypeFilter);
            refreshDropdown('company', filterdata.Companies, filterdata.SelectedCompany ? filterdata.SelectedCompany.Name : null);
            refreshDropdown('year', filterdata.Years, filterdata.YearFilter);

            function refreshDropdown(dropdownFor, data, selectedValue) {
              var $dropdown = $filterRow.find('select[data-param=' + dropdownFor + ']');
              // Remove all options from existing dropdown except first default value
              $dropdown.find('option').eq(0).siblings().remove();
              // Fill the dropdown with new values
              var name,
                description;
              $.each(data, function (i, option) {
                if (dropdownFor === "year") {
                  name = option;
                  description = option;
                }
                else if (dropdownFor === "type") {
                  name = i;
                  description = option;
                }
                else {
                  name = option.Name;
                  description = option.LocalizedDescription;
                }

                $dropdown.append('<option value=' + name + '>' + description + '</option>');
              });
              $dropdown.val(selectedValue);
              $dropdown.niceSelect('update');
            }

            filteringCallback(container, url);
          }
        );
      }
      else {
        filteringCallback(container, url);
      }

    }
    history.pushState(null, null, historyUrl);
    checkQueryIsEmpty($clearButton);
  });

  $clearButton.on('click', function (e) {
    var $this = $(this);
    if (typeof (filteringCallback) !== 'undefined' && !$this.hasClass('disabled')) {
      if (pageType === 'ReleaseListingPage') {
        container.parents('.container-fluid').addClass('loading');
        filtersUrl = currentLocation + '/RefreshFilters?' + 'type=&company=&year=&q=';
        $.get(
          filtersUrl + '&filters=true',
          function (filterdata) {
            var $filterRow = $('.filterRow');
            container.closest('div.container-fluid').removeClass('loading');



            refreshDropdown('type', filterdata.ReleaseTypes, filterdata.TypeFilter);
            refreshDropdown('company', filterdata.Companies, filterdata.SelectedCompany ? filterdata.SelectedCompany.Name : null);
            refreshDropdown('year', filterdata.Years, filterdata.YearFilter);



            function refreshDropdown(dropdownFor, data, selectedValue) {
              var $dropdown = $filterRow.find('select[data-param=' + dropdownFor + ']');
              // Remove all options from existing dropdown except first default value
              $dropdown.find('option').eq(0).siblings().remove();
              // Fill the dropdown with new values
              var name,
                description;
              $.each(data, function (i, option) {
                if (dropdownFor === "year") {
                  name = option;
                  description = option;
                }
                else if (dropdownFor === "type") {
                  name = i;
                  description = option;
                }
                else {
                  name = option.Name;
                  description = option.LocalizedDescription;
                }



                $dropdown.append('<option value=' + name + '>' + description + '</option>');
              });
              $dropdown.val('');
              $dropdown.niceSelect('update');
            }



            filteringCallback(container, currentLocation + '?q');
          }
        );



        history.pushState(null, null, currentLocation);
        container.find('select#TimingSelect').eq(0).val(container.find('select#TimingSelect option').eq(0).val());
        container.find('input').val('');
      }
      else if (pageType === "events") {
        var blockId = container.find('.listingResults').data('block-id'),
          language = container.find('.listingResults').data('language');
        url = '/LoadContentApi/Events?contentId=' + blockId + '&language=' + language + '&skip=0';
        filteringCallback(container, url);
        history.pushState(null, null, currentLocation);
        container.find('select').val('');
        container.find('select#TimingSelect').eq(0).val(container.find('select#TimingSelect option').eq(0).val());
        container.find('select').niceSelect('update');
        container.find('input').val('');
      }
      else if (pageType === "blogs") {
        url = currentLocation + '/filter' ;
        filteringCallback(container, url);
        history.pushState(null, null, currentLocation);
        container.find('select').val('');
        container.find('select#TimingSelect').eq(0).val(container.find('select#TimingSelect option').eq(0).val());
        container.find('select').niceSelect('update');
        container.find('input').val('');
      }
      else {
        filteringCallback(container, currentLocation + '?q');
        history.pushState(null, null, currentLocation);
        container.find('select').val('');
        container.find('select#TimingSelect').eq(0).val(container.find('select#TimingSelect option').eq(0).val());
        container.find('select').niceSelect('update');
        container.find('input').val('');
      }
    }
    $this.addClass('disabled');
    e.preventDefault();
  });

  checkQueryIsEmpty($clearButton);

  // Reinitiate search input bindings
  initSearch(container.find('.search'));
};

//PICKS PARAMETERS FROM URL
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

//ENCODE QUERY STRING
function encodeQueryData(data) {
  var ret = [];
  for (var d in data) {
    // To avoid comma issue in the filter values
    if ($('#isJobListingPage').val() == "YES") {
      var res = '';
      if (typeof (data[d]) == 'object') {
        for (var i = 0; i < data[d].length; i++) {
          res += data[d][i] + ";";
        }
      }
      else {
        res += data[d] + ";";
      }

      res = res.substring(0, res.length - 1);
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(res));
    }
    else {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
  }
  return ret.join('&');
}

/* ----------------------------  cookies -----------------------------------
-------------------------------------------------------------------------- */

function setCookie(name, value, days) {
  deleteCookie(name);
  createCookie(name, value, days);
}

function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toUTCString();
  }
  else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function deleteCookie(name) {
  createCookie(name, "", -1);
}

function SocialMediaFeedBlock$ShowMorePosts(blockId, culture, $grid) {
  $('.socialMediaFeedShowMoreBtn').addClass('disabled loading');

  $.get("/SocialMediaFeedBlockController/LoadMore/" + blockId + "/" + culture, function (data) {
    var $targetContainer = $(".socialMediaFeedBlock");
    var $tempContainer = $(document.createElement('div'));
    $tempContainer.html($.parseHTML(data));
    var $feeds = $tempContainer.find('.feed');
    $feeds.find('img').lazyload();
    $grid.append($feeds);
    $feeds.imagesLoaded().done(function (instance) {
      $grid.masonry('appended', $feeds);
      $feeds.find('img').trigger("scroll");
    })

    // set the show more from received HTML
    if ($tempContainer.find('.socialMediaFeedShowMoreBtn').length)
      $('.socialMediaFeedShowMoreBtn').removeClass('disabled loading');
  });
}

function equalHeights() {
  var $equalHeights = $('.equalheight-container');

  $equalHeights.each(function () {
    var $equalHeightsItems = $equalHeights.find('.equalheight-item');
    var biggestHeight = 0;
    $equalHeightsItems.css('minHeight', '');
    $equalHeightsItems.each(function () {
      var $this = $(this);
      if ($this.outerHeight() > biggestHeight) {
        biggestHeight = $this.outerHeight();
      }
    });
    $equalHeightsItems.css('minHeight', biggestHeight + 'px');
  });
}

$(document).ready(function (e) {
  $('body').on('click', 'a.load-sub-nav', function (e) {
    e.preventDefault();
    var loadNavLink = this;
    var navLink = $(this).attr("href");

    if (navLink === "#") {
      return;
    }

    $.ajax({
      type: "GET",
      url: "/CommonAjaxMethods/GetSubnavigation",
      data: { linkUrl: window.location.protocol + "//" + window.location.host + navLink, currentlang: $('html').attr('lang') },
      success: function (response) {
        if (response.length) {
          //var dMenu = $(loadNavLink).parents(".dropdown-menu");
          var subNavDiv = $(loadNavLink).parents(".dropdown-menu").find(".subNavBlock");
          if (subNavDiv.length) {
            $(subNavDiv).replaceWith(response);
          }
          //console.log(response);
        }
        else {
          console.log(response);
        }
      },
      error: function (response) {
        console.log(response);
      }
    });
  });

  //quote block in Tiny Mce Editor
  var blockqQuote = $("blockquote");
  var paragraph = blockqQuote.find("p");
  paragraph.wrap("<div></div>");

  if ($(".navbar-nav .rightSideLifts .modal, .twoColumnContactBlock .modal").length) {
    $(".navbar-nav .rightSideLifts .modal, .twoColumnContactBlock .modal").each(function (e) {
      if (!$('body>#' + $(this).attr('id')).length) {
        $(this).appendTo("body");
      }
      else {
        $(this).replaceWith("&nbsp;");
      }
    });

  }

  $(".dropdown-toggle a").click(function () {
    $('.dropdown-menu').css('display', 'none');
    $('.dropdown-toggle .icon-arrowBreadcrumb').addClass('arrowdegree');
    location.href = this.href;
  });

  // press release with go to location anchors
  if ($(window).width() > 992) {
    $('.press-release-list ol li a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - 65
            }, 1000, function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });
  }

  $.fn.setMinHeight = function (setCount) {
    for (var i = 0; i < this.length; i += setCount) {
      var curSet = this.slice(i, i + setCount),
        height = 0;
      curSet.each(function () { height = Math.max(height, $(this).height()); })
        .css('min-height', height);
      console.log(height);
    }
    return this;
  };

  $(".MicrositePage .jobBlock").each(function (index) {
    $(this).find(".tile h3").setMinHeight(3);
  });

  //video block css
  if ($('.container-fluid').hasClass("local-video-block") || $('div').hasClass("business-label-block")) {
    $('.jumbotron.heroImage').css("margin-bottom", "0");
  }
  //business label block css
  if ($('div').hasClass("business-label-block")) {
    $('.local-video-block_desktop, .local-video-block_mobile').css("margin-bottom", "-1px");
  }

  if ($(window).width() < 768) {
    if ($('div').hasClass("business-label-block")) {
      $('.business-label-block').closest('.container-fluid').css("margin-top", "0");
    }
  }

  $('body').find('.campaignJobBlockLoadMore').bind('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    $('body').prepend('<div class="microsite-loading"> <svg class="icon icon_loader" style="position:absolute; left:50%; top:50%"><use xlink:href="#icon_loader"></use></svg></div > ');
    let currentBlock = $(this).attr('data');
    let appendHere = currentBlock;
    let currentBlockID = currentBlock;
    let skip = $("#jobSkipCount").val() || 0;
    let language = $(this).attr('data-language');

    $.ajax({
      type: "GET",
      url: "/LoadContentApi/Jobs?contentId=" + currentBlockID + "&language=" + language + "&skip=" + skip,
      contentType: 'application/json; charset=utf-8',
      success: function (data) {
        $('.' + appendHere).append(data);

        // Find the element and get the updated value
        $("#jobSkipCount").val($("<div/>", { html: data }).find("#jobSkipCount").val());

        $('.microsite-loading').hide();
        $(".MicrositePage .jobBlock").each(function (index) {
          $(this).find(".tile h3").setMinHeight(3);
        });
      },
      error: function () {
        console.log("Error");
      }

    });

  });

  if ($('.navbar-nav>.nav-item>.nav-link').length) {
    var clickEvent = ((document.ontouchstart !== null) ? 'click' : 'undefined');
    if (clickEvent !== 'undefined') {
      $('.navbar-nav>.nav-item>.nav-link').on('click', function (e) {
        var link = $(this).attr('href');
        var ismobile = window.innerwidth < 992;
        if (link !== "#" && !ismobile && e.type === 'click') {
          e.stopPropagation();
          e.preventDefault();
          window.location = link;
          return false;
        }
      });
    }
  }

  if (!$('body').hasClass('MicrositePage')) {
    if (window.location.hash !== "" && $(window.location.hash).length) {
      if ($(window.location.hash).hasClass('modal')) {
        $(window.location.hash).modal();
      }
      else {
        $('html,body').animate({
          scrollTop: $(window.location.hash).offset().top - 50
        },
          'slow');
      }
    }
    $(".registrationBtn").click(function (e) {
      var url = $(this).attr('href');
      if (url !== "" && url.length && url.indexOf('#')) {
        var formId = url.substr(url.indexOf('#'));
        if (formId !== "" && formId.length && formId.indexOf('#') == 0) {
          e.preventDefault();
          $('html,body').animate({
            scrollTop: $(formId).offset().top - 50
          },
            'slow');
        }
      }
    });
  }
});

var initVideoButtons = function () {
  $('a.video').on('click', function (e) {
    // Fix for bug causing excsessive zoom on image and video gallery modal on mobile safari (ios9)
    document.querySelector('meta[name="viewport"]').content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';
    var mediaYoutubeRetPos = $(window).scrollTop();
    showVideo($(this), false, mediaYoutubeRetPos);
    $('#videoContainer').show(); // show the modal
  });
}

// WebinarListingPage video modal
var showVideo = function (elem, ifShare, mediaYoutubeRetPos) {
  $('.WebinarListingPage .container-fluid').append('<div id="videoLayer"></div>');
  $(".pictureContainer").insertAfter($('#webinars'));

  $('.pictureContainer .title').html($(elem).attr("title"));

  if ($(elem).attr("data-description") !== "") {
    $('.pictureContainer .publish').html($(elem).attr("data-description"));
  }


  var tag = document.createElement('script');
  tag.src = "//www.youtube.com/player_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var galleryVideoUrl = $(elem).attr("data-video-url");
  $("#videoContainer .video").html('<iframe id="ytvideo" frameborder="0" allowfullscreen scrolling="no"  referrerpolicy="strict-origin-when-cross-origin" allowtransparency="true" src="' + galleryVideoUrl + "?wmode=transparent&enablejsapi=1&version=3&playerapiid=ytplayer" + '" wmode="Opaque"></iframe>');


  // Fix for bug causing excsessive zoom on image and video gallery modal on mobile safari (ios9)
  document.querySelector('meta[name="viewport"]').content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';

  var target = null;
  var position = "";

  var $webinarCard = $(elem).parent().parent();
  if ($webinarCard.next().length === 0) {
    target = $webinarCard;
    position = "last";
  }
  else if ($webinarCard.next().length !== 0 && ($webinarCard.offset().top !== $webinarCard.next().offset().top)) {
    target = $webinarCard;
    position = "last";
  }
  else if ($webinarCard.next().next().length !== 0 && $webinarCard.offset().top !== $webinarCard.next().next().offset().top) {
    target = $webinarCard.next();
    window.innerWidth < 959 ? position = "first" : position = "middle";
  } else {
    if ($webinarCard.next().next().length !== 0) {
      target = $webinarCard.next().next();
    }
    else if ($webinarCard.next().length !== 0) {
      target = $webinarCard.next();
    }
    else {
      target = $webinarCard;
    }
    position = "first";
  }
  $(".pictureContainer").insertAfter(target);


  $('.pictureContainer').show();

  //finding position to scroll to
  var offset = 0;
  window.innerWidth < 768 || $('html').hasClass('no-touch') ? offset = 110 : offset = 60;

  if (ifShare) {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }
  setTimeout(function () {
    $('html, body').animate({ scrollTop: $('#videoContainer').offset().top - offset }, 0);
  }, 1500);

  //Animate picture container
  $(".pictureContainer").animate({
    paddingBottom: '30px',
    paddingTop: '30px',
    marginBottom: '30px'
  });


  $("#videoLayer").on('click', function () {
    $('#ytvideo')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
    $('.pictureContainer').attr("style", "");
    $('.pictureContainer').hide();
    $("#videoLayer").remove();
  });


  if ($('#videoContainer').length > 0) {

    $(".pictureContainer .roundedBtn.close").on('click', function () {
      $('#ytvideo')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      $('.pictureContainer').attr("style", "");
      $('.pictureContainer').hide();
      $('[id="videoLayer"]').remove();
      if (mediaYoutubeRetPos > 0) {
        $(window).scrollTop(mediaYoutubeRetPos);
      }
      mediaYoutubeRetPos = 0;
    });

  }

}

if ($("#ShowModelPopup").length > 0 && $("#ShowModelPopup").val() == 'True') {
  window.onload = function () {
    $("#modal_" + $("#ModelId").val()).modal("show");
  }
}